export default __webpack_public_path__ + "static/media/X.18bf3aca.svg";